// ジョブステータス
export const job_status = {
  'PENDING': '0', // 未実行
  'RUNNING': '1', // 実行中
  'HASERROR': '2', // エラーあり
  'CANCELED': '3', // 中止
  'FINISHED': '4' // 完了
}



// WEBPACK FOOTER //
// ./src/components/pages/admin/appsuitejobs/constants.js